export default function PHP_fileinode() {
  return (
    <div>
      <h1>PHP_fileinode</h1>
    </div>
  );
}
